<template>
    <div class="shadow overflow-hidden">
        <div>
            <dl>
                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.document_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ employeetrainingfile.document_name }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.file_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        <p class="cursor-pointer text-blue-600 underline" @click="download(employeetrainingfile.file_name, '/download-employee-training-file', employeetrainingfile.id)" :title="employeetrainingfile.file_name">
                            {{ employeetrainingfile.file_name }}
                        </p>
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.created_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ employeetrainingfile.created_by }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.updated_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ employeetrainingfile.updated_by }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.created_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ employeetrainingfile.created_at }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('employeetrainingfile.updated_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ employeetrainingfile.updated_at }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from '@/boot/axios'
import { useToast } from 'vue-toastification'

export default {
  name: 'EmployeeTrainingFileDetail',
  components: {},
  props: {
    propEmployeeTrainingFile: {
      type: Object,
      default: () => ({ empty: true })
    }
  },
  emits: ['close-modal', 'submit'],
  setup(props, { emit }) {
    const toast = useToast()
    const titleStack = ref(['Admin', 'Details'])

    const employeetrainingfile = reactive({
      id: '',
      employee_training_id: '',
      employee_training_name: '',
      document_name: '',
      file_name: '',
      created_by: '',
      updated_by: '',
      created_at: '',
      updated_at: ''
    })

    const download = (name, url, id) => {
        const params = { filename: name, id }

        axios
            .get(url, { params, responseType: 'blob' })
            .then((response) => {
                triggerDownload(response.data, name)
            })
            .catch((error) => {
                console.error('Primary download failed:', error)
                // toast.error('Download failed: ' + (error.response?.data?.message || error.message))

                // Fallback
                downloadDoc(name, id)
            })
    }

    const downloadDoc = (name, id) => {
        const params = { filename: name, id }

        axiosDocument
            .get('/download-employee-training-file', { params, responseType: 'blob' })
            .then((response) => {
                triggerDownload(response.data, name)
            })
            .catch((error) => {
                console.error('Fallback download failed:', error)
                toast.error('Fallback failed: ' + (error.response?.data?.message || error.message))
            })
    }

    const triggerDownload = (blobData, filename) => {
        const fileURL = window.URL.createObjectURL(new Blob([blobData]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
        document.body.removeChild(fileLink)
        window.URL.revokeObjectURL(fileURL)
    }

    watchEffect(() => {
      const newEmployeeTrainingFile = props.propEmployeeTrainingFile
      // console.log('propEmployeeTrainingFile', newEmployeeTrainingFile)
    //   if (newEmployeeTrainingFile && Object.keys(newEmployeeTrainingFile).length > 0 && !newEmployeeTrainingFile.empty) {
        Object.assign(employeetrainingfile, newEmployeeTrainingFile)
    //   }
    })

    return {
      titleStack,
      employeetrainingfile,
      download,
      downloadDoc
    }
  }
}
</script>
